(function(){
  var doc=document, root=doc.documentElement;
  var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
  var coarse=matchMedia('(pointer:coarse)').matches;
  root.classList.add('js');
  var M={x:innerWidth/2,y:innerHeight/2,px:innerWidth/2,py:innerHeight/2};
  addEventListener('mousemove',function(e){M.x=e.clientX;M.y=e.clientY;},{passive:true});

  /* ---------- drifting soursop leaves (background) ---------- */
  (function(){
    var cv=doc.getElementById('field'),x=cv.getContext('2d'),W,H,DPR=Math.min(devicePixelRatio||1,2);
    function sz(){W=cv.width=innerWidth*DPR;H=cv.height=innerHeight*DPR;cv.style.width=innerWidth+'px';cv.style.height=innerHeight+'px';}
    sz();addEventListener('resize',sz);
    var GREENS=[[139,168,138],[166,200,156],[112,146,108],[126,158,116]];
    function lighten(c,n){return [Math.min(255,c[0]+n),Math.min(255,c[1]+n),Math.min(255,c[2]+n)];}
    /* the foliage — tumbling leaves of varied size and depth */
    var LFN=coarse?8:15, leaves=[];
    for(var i=0;i<LFN;i++){var g=GREENS[(Math.random()*GREENS.length)|0];var depth=Math.random();var big=depth>.66;
      leaves.push({x:Math.random()*W,y:Math.random()*H,L:(big?Math.random()*78+62:Math.random()*42+26)*DPR,rot:Math.random()*6.28,spin:(Math.random()-.5)*.005,sway:Math.random()*6.28,swaySp:Math.random()*.015+.006,vx:(Math.random()-.5)*.18*DPR,vy:(Math.random()*.11+.03)*DPR,a:(big?.12:.2)+Math.random()*.12,bp:Math.random()*6.28,bsp:Math.random()*.02+.01,c:g,glow:big?16:9});}
    /* faint gold light motes drifting up — soft canopy light */
    var PLN=coarse?10:20, motes=[];
    for(var i=0;i<PLN;i++){motes.push({x:Math.random()*W,y:Math.random()*H,r:(Math.random()*1.2+.4)*DPR,ph:Math.random()*6.28,sp:Math.random()*.03+.01,vx:(Math.random()-.5)*.05*DPR,vy:-(Math.random()*.12+.04)*DPR});}
    var ripples=[];
    addEventListener('mousedown',function(e){ripples.push({x:e.clientX*DPR,y:e.clientY*DPR,r:0});});
    var t=0, MR=(165*DPR)*(165*DPR);

    /* pointed soursop leaf with light-to-shadow gradient, glow + veins */
    function drawLeaf(l){
      var lightT=root.getAttribute('data-theme')==='light';
      var a=l.a*(0.78+0.22*Math.sin(l.bp))*(lightT?1.45:1);
      x.save();x.translate(l.x,l.y);x.rotate(l.rot+Math.sin(l.sway)*0.16);
      var L=l.L,base=l.c,w=L*0.34,c,lc;
      if(lightT){c=[Math.round(base[0]*0.66),Math.round(base[1]*0.7),Math.round(base[2]*0.6)];lc=[Math.round(c[0]*0.8),Math.round(c[1]*0.84),Math.round(c[2]*0.72)];}
      else{c=base;lc=lighten(c,46);}
      x.beginPath();x.moveTo(-L*0.5,0);x.quadraticCurveTo(-L*0.1,-w,L*0.32,-w*0.5);x.quadraticCurveTo(L*0.5,-w*0.18,L*0.52,0);x.quadraticCurveTo(L*0.5,w*0.18,L*0.32,w*0.5);x.quadraticCurveTo(-L*0.1,w,-L*0.5,0);x.closePath();
      var grad=x.createLinearGradient(-L*0.5,w,L*0.52,-w);
      grad.addColorStop(0,'rgba('+c[0]+','+c[1]+','+c[2]+','+a+')');
      grad.addColorStop(1,'rgba('+lc[0]+','+lc[1]+','+lc[2]+','+Math.min(1,a*1.5)+')');
      x.shadowColor='rgba('+lc[0]+','+lc[1]+','+lc[2]+','+Math.min(.6,a*2)+')';x.shadowBlur=l.glow*DPR;
      x.fillStyle=grad;x.fill();
      x.shadowBlur=0;
      x.strokeStyle='rgba('+lc[0]+','+lc[1]+','+lc[2]+','+(a*1.7)+')';x.lineWidth=DPR;x.stroke();
      x.beginPath();x.moveTo(-L*0.5,0);x.lineTo(L*0.52,0);x.strokeStyle='rgba('+lc[0]+','+lc[1]+','+lc[2]+','+(a*1.3)+')';x.lineWidth=DPR*.7;x.stroke();
      for(var v=1;v<=3;v++){var vx=(-L*0.5)+v/4*L;x.beginPath();x.moveTo(vx,0);x.quadraticCurveTo(vx+L*0.08,-w*0.28,vx+L*0.14,-w*0.42);x.moveTo(vx,0);x.quadraticCurveTo(vx+L*0.08,w*0.28,vx+L*0.14,w*0.42);x.stroke();}
      x.restore();
    }
    function step(){
      t+=0.004; x.clearRect(0,0,W,H);
      var mx=M.x*DPR,my=M.y*DPR;
      for(var i=0;i<motes.length;i++){var pl=motes[i];pl.ph+=pl.sp;pl.x+=pl.vx;pl.y+=pl.vy;
        if(pl.y<-4)pl.y=H+4;if(pl.x<0)pl.x=W;if(pl.x>W)pl.x=0;
        var tw=0.3+0.7*Math.abs(Math.sin(pl.ph));
        x.beginPath();x.arc(pl.x,pl.y,pl.r,0,7);x.fillStyle='rgba(201,160,80,'+(tw*0.5)+')';x.fill();}
      for(var s=ripples.length-1;s>=0;s--){var rp=ripples[s];rp.r+=7*DPR;if(rp.r>Math.max(W,H)){ripples.splice(s,1);continue;}
        x.beginPath();x.arc(rp.x,rp.y,rp.r,0,7);x.strokeStyle='rgba(166,200,156,'+Math.max(0,.34-rp.r/Math.max(W,H))+')';x.lineWidth=1.5*DPR;x.stroke();}
      for(var i=0;i<leaves.length;i++){var l=leaves[i];l.sway+=l.swaySp;l.bp+=l.bsp;l.rot+=l.spin;
        l.x+=l.vx;l.y+=l.vy;
        var dx=l.x-mx,dy=l.y-my,dm=dx*dx+dy*dy;
        if(dm<MR){var ff=(1-dm/MR),d=Math.sqrt(dm)||1;l.x+=(dx/d)*ff*2.4*DPR;l.y+=(dy/d)*ff*2.4*DPR;l.rot+=ff*0.025;}
        for(var s3=0;s3<ripples.length;s3++){var rp2=ripples[s3];var rdx=l.x-rp2.x,rdy=l.y-rp2.y,rd=Math.sqrt(rdx*rdx+rdy*rdy)||1;if(Math.abs(rd-rp2.r)<54*DPR){l.x+=(rdx/rd)*2.2*DPR;l.y+=(rdy/rd)*2.2*DPR;l.rot+=0.035;}}
        if(l.x<-l.L)l.x=W+l.L;if(l.x>W+l.L)l.x=-l.L;if(l.y<-l.L)l.y=H+l.L;if(l.y>H+l.L)l.y=-l.L;
        drawLeaf(l);}
      requestAnimationFrame(step);
    }
    if(!reduce)step(); else {for(var b=0;b<leaves.length;b++)drawLeaf(leaves[b]);}
  })();

  /* ---------- custom cursor ---------- */
  if(!coarse){
    var cur=doc.querySelector('.cur'),ring=doc.querySelector('.ring'),rx=M.x,ry=M.y;
    (function loop(){rx+=(M.x-rx)*.2;ry+=(M.y-ry)*.2;
      cur.style.transform='translate('+M.x+'px,'+M.y+'px) translate(-50%,-50%)';
      ring.style.transform='translate('+rx+'px,'+ry+'px) translate(-50%,-50%)';requestAnimationFrame(loop);})();
    doc.addEventListener('mouseover',function(e){if(e.target.closest('a,button,.chip,.preset,summary,.btn,.pbuy,input'))ring.classList.add('hot');else ring.classList.remove('hot');});
  }

  /* ---------- progress + nav ---------- */
  var bar=doc.getElementById('bar'),nav=doc.getElementById('nav');
  (function up(){var m=root.scrollHeight-root.clientHeight;bar.style.width=((m>0?root.scrollTop/m:0)*100).toFixed(2)+'%';nav.classList.toggle('solid',root.scrollTop>40);requestAnimationFrame(up);})();

  /* ---------- split headline ---------- */
  var allChars=[];
  doc.querySelectorAll('[data-split]').forEach(function(el){
    var txt=el.textContent, frag=doc.createDocumentFragment();
    txt.split('').forEach(function(c){var s=doc.createElement('span');s.className='ch';s.textContent=c===' '?' ':c;frag.appendChild(s);allChars.push(s);});
    el.textContent='';el.appendChild(frag);
  });
  allChars.forEach(function(s,i){s.style.transform='translateY(118%)';s.style.transition='transform .9s cubic-bezier(.16,1,.3,1)';s.style.transitionDelay=(0.2+i*0.018)+'s';});
  requestAnimationFrame(function(){requestAnimationFrame(function(){allChars.forEach(function(s){s.style.transform='translateY(0)';});});});
  if(!coarse&&!reduce){
    (function magLoop(){
      for(var i=0;i<allChars.length;i++){var s=allChars[i];var r=s.getBoundingClientRect();if(r.top>innerHeight||r.bottom<0){if(s.style.translate)s.style.translate='0 0';continue;}var cx=r.left+r.width/2,cy=r.top+r.height/2;var dx=cx-M.x,dy=cy-M.y,dm=dx*dx+dy*dy;
        if(dm<19000){var f=(1-dm/19000);var d=Math.sqrt(dm)||1;s.style.translate=(dx/d*f*14).toFixed(1)+'px '+(dy/d*f*14).toFixed(1)+'px';}else if(s.style.translate){s.style.translate='0 0';}}
      requestAnimationFrame(magLoop);
    })();
  }

  /* ---------- rotating hook (clean typewriter, no scramble) ---------- */
  (function(){
    var el=doc.getElementById('scram');if(!el)return;
    var qs=['collagen you lose a little more of every day','vitamin C that oxidizes before it ever lands','15 products that fight each other on your face','67% of actives that never reach a cell','$200 a month for skin that looks the same'];
    if(reduce){el.textContent=qs[0];return;}
    var qi=0,ci=0,del=false;
    function tick(){
      var w=qs[qi];
      if(!del){ci++;el.textContent=w.slice(0,ci);if(ci>=w.length){del=true;return void setTimeout(tick,1700);}}
      else{ci--;el.textContent=w.slice(0,ci);if(ci<=0){del=false;qi=(qi+1)%qs.length;return void setTimeout(tick,280);}}
      setTimeout(tick,del?26:52);
    }
    setTimeout(tick,900);
  })();

  /* ---------- magnetic + tilt + parallax ---------- */
  if(!coarse&&!reduce){doc.querySelectorAll('.mag').forEach(function(el){
    el.addEventListener('mousemove',function(e){var r=el.getBoundingClientRect();el.style.transform='translate('+((e.clientX-(r.left+r.width/2))*.3)+'px,'+((e.clientY-(r.top+r.height/2))*.4)+'px)';});
    el.addEventListener('mouseleave',function(){el.style.transform='';});});
    doc.querySelectorAll('.tilt').forEach(function(el){
    el.addEventListener('mousemove',function(e){var r=el.getBoundingClientRect();var px=(e.clientX-r.left)/r.width-.5,py=(e.clientY-r.top)/r.height-.5;el.style.transform='perspective(900px) rotateY('+(px*7)+'deg) rotateX('+(-py*7)+'deg) translateY(-5px)';});
    el.addEventListener('mouseleave',function(){el.style.transform='';});});
    (function par(){M.px+=(M.x-M.px)*.06;M.py+=(M.y-M.py)*.06;var nx=(M.px/innerWidth-.5),ny=(M.py/innerHeight-.5);
      doc.querySelectorAll('.par').forEach(function(el){var d=parseFloat(el.getAttribute('data-par'))||.4;el.style.transform='translate('+(nx*40*d)+'px,'+(ny*40*d)+'px)';});requestAnimationFrame(par);})();
  }

  /* ---------- reveals + count-up + section draw triggers ---------- */
  function counter(el){if(el.dataset.d)return;el.dataset.d=1;var end=parseFloat(el.getAttribute('data-count')),suf=el.getAttribute('data-suffix')||'',pre=el.getAttribute('data-prefix')||'',raw=el.getAttribute('data-raw'),t0=null;
    function st(t){if(!t0)t0=t;var p=Math.min((t-t0)/1500,1),v=(1-Math.pow(1-p,3))*end,disp;
      if(raw)disp=(end%1!==0?v.toFixed(1):Math.round(v));else{disp=Math.round(v);if(end>=1000)disp=disp.toLocaleString('en-US');}
      el.textContent=pre+disp+suf;if(p<1)requestAnimationFrame(st);}requestAnimationFrame(st);}
  var revs=[].slice.call(doc.querySelectorAll('.rev'));
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');e.target.querySelectorAll('.n[data-count]').forEach(counter);io.unobserve(e.target);}});},{threshold:.14,rootMargin:'0px 0px -7% 0px'});
    revs.forEach(function(el){io.observe(el);});
    var draws=[['loopWrap'],['graph']];
    [doc.getElementById('loopWrap'),doc.getElementById('graph')].forEach(function(el){if(!el)return;var d=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('draw');d.unobserve(e.target);}});},{threshold:.3});d.observe(el);});
  }else{revs.forEach(function(el){el.classList.add('in');});[doc.getElementById('loopWrap'),doc.getElementById('graph')].forEach(function(el){if(el)el.classList.add('draw');});}

  /* ---------- scroll-illuminate ---------- */
  (function(){
    var blocks=[].slice.call(doc.querySelectorAll('[data-illum]'));if(!blocks.length)return;
    blocks.forEach(function(b){
      var keys=(b.getAttribute('data-keys')||'').split('|').filter(Boolean);
      var words=b.textContent.split(/(\s+)/),frag=doc.createDocumentFragment();
      b.textContent='';
      words.forEach(function(tok){
        if(/^\s+$/.test(tok)){frag.appendChild(doc.createTextNode(tok));return;}
        var clean=tok.replace(/[^a-zA-Z0-9%']/g,'');
        var s=doc.createElement('span');s.className='w';
        if(keys.indexOf(clean)>-1)s.className+=' key';
        s.textContent=tok;frag.appendChild(s);
      });
      b.appendChild(frag);b._words=[].slice.call(b.querySelectorAll('.w'));
    });
    if(reduce)return;
    function upd(){
      for(var bi=0;bi<blocks.length;bi++){var ws=blocks[bi]._words;
        for(var i=0;i<ws.length;i++){var r=ws[i].getBoundingClientRect();ws[i].classList.toggle('lit',r.top<innerHeight*0.82);}}
      requestAnimationFrame(upd);
    }
    requestAnimationFrame(upd);
  })();

  /* ---------- E3 interactive ecosystem collapse ----------
     LOGIC: balance% == the share of cells that are still alive.
     Each product kills a proportional set of cells (they shrink, darken,
     go inert and drop their links). Hits sum to 67 → all-on = 33% alive
     = the "67% never reaches a living cell" stat. Fully reversible. */
  (function(){
    var cv=doc.getElementById('petriC');if(!cv)return;
    var x=cv.getContext('2d'),W,H,DPR=Math.min(devicePixelRatio||1,2);
    function sz(){var box=cv.getBoundingClientRect();W=cv.width=Math.max(2,box.width*DPR);H=cv.height=Math.max(2,box.height*DPR);}
    sz();addEventListener('resize',sz);
    var N=coarse?30:54, cells=[];
    for(var i=0;i<N;i++){var _a=Math.random()*6.283,_rd=Math.sqrt(Math.random())*0.44;cells.push({x:0.5+Math.cos(_a)*_rd,y:0.5+Math.sin(_a)*_rd,vx:(Math.random()-.5),vy:(Math.random()-.5),r:Math.random()*3.6+4.2,ph:Math.random()*6.28,sp:Math.random()*.03+.02,vit:1});}
    var PAL={dark:{a:[166,200,156],d:[207,150,110],x:[78,90,76],link:'139,168,138'},light:{a:[58,112,72],d:[176,100,60],x:[140,142,130],link:'58,112,72'}};
    function mix(a,b,f){return [Math.round(a[0]+(b[0]-a[0])*f),Math.round(a[1]+(b[1]-a[1])*f),Math.round(a[2]+(b[2]-a[2])*f)];}
    var health=100, target=100, t=0, shocks=[];
    var pctEl=doc.getElementById('petriPct'),noteEl=doc.getElementById('petriNote');
    var chips=[].slice.call(doc.querySelectorAll('#chips .chip'));
    function activeCount(){var on=0;chips.forEach(function(c){if(c.classList.contains('on'))on++;});return on;}
    function recompute(){var hit=0;chips.forEach(function(c){if(c.classList.contains('on'))hit+=parseFloat(c.getAttribute('data-hit'));});target=Math.max(0,100-hit);}
    function note(on){if(on===0){noteEl.innerHTML='A balanced ecosystem — every cell alive, connected, calm.';return;}
      noteEl.innerHTML='<b>'+on+(on>1?' products in.':' product in.')+'</b> '+Math.round(health)+'% of cells still alive · <b>'+Math.round(100-health)+'% of your actives never reach one.</b>';}
    chips.forEach(function(c){c.addEventListener('click',function(){c.classList.toggle('on');recompute();
      if(c.classList.contains('on')){noteEl.innerHTML=c.getAttribute('data-msg');if(!reduce)shocks.push({x:.5,y:.5,r:0});}else{note(activeCount());}});});
    doc.getElementById('petriReset').addEventListener('click',function(){chips.forEach(function(c){c.classList.remove('on');});recompute();note(0);});
    note(0);
    function frame(){
      t+=0.01; health+=(target-health)*(reduce?1:0.055);
      var h=health/100, agit=0.4+(1-h)*1.9, alive=Math.round(N*h), MD=Math.max(W,H);
      var _p=PAL[root.getAttribute('data-theme')==='light'?'light':'dark'],ALIVE=_p.a,DYING=_p.d,DEAD=_p.x,linkRGB=_p.link;
      pctEl.textContent=Math.round(health)+'%';
      pctEl.classList.toggle('warn',health<67);
      x.clearRect(0,0,W,H);
      /* disturbance shockwaves from newly added products */
      for(var s=shocks.length-1;s>=0;s--){var sk=shocks[s];sk.r+=0.022;if(sk.r>1.45){shocks.splice(s,1);continue;}
        x.beginPath();x.arc(sk.x*W,sk.y*H,sk.r*MD*0.5,0,7);x.strokeStyle='rgba(207,150,110,'+Math.max(0,.5-sk.r/1.45)+')';x.lineWidth=1.4*DPR;x.stroke();}
      /* update cells: vitality by rank, agitation by health, shock push */
      for(var i=0;i<cells.length;i++){var c=cells[i];c.ph+=c.sp;
        var tv=(i<alive)?1:0; c.vit+=(tv-c.vit)*(reduce?1:0.045);
        if(!reduce){var sp=0.0006*(0.5+0.5*c.vit);c.x+=c.vx*sp;c.y+=c.vy*sp;}
        var ddx=c.x-0.5,ddy=c.y-0.5,dr=Math.sqrt(ddx*ddx+ddy*ddy)||1;
        if(dr>0.455){var nx=ddx/dr,ny=ddy/dr;c.x=0.5+nx*0.455;c.y=0.5+ny*0.455;var dot=c.vx*nx+c.vy*ny;c.vx-=2*dot*nx;c.vy-=2*dot*ny;}
      }
      /* membrane links — only between living cells */
      var LINK=(W*0.26)*(W*0.26);
      for(var i=0;i<cells.length;i++){var p=cells[i];if(p.vit<0.5)continue;var px=p.x*W,py=p.y*H;
        for(var j=i+1;j<cells.length;j++){var q=cells[j];if(q.vit<0.5)continue;var qx=q.x*W,qy=q.y*H,dx=px-qx,dy=py-qy,dd=dx*dx+dy*dy;
          if(dd<LINK){x.beginPath();x.moveTo(px,py);x.lineTo(qx,qy);x.strokeStyle='rgba('+linkRGB+','+(.28*(1-dd/LINK)*Math.min(p.vit,q.vit))+')';x.lineWidth=DPR*.6;x.stroke();}}
      }
      /* draw cells */
      for(var i=0;i<cells.length;i++){var c=cells[i],vit=c.vit,col;
        if(vit>0.5)col=mix(DYING,ALIVE,(vit-0.5)/0.5); else col=mix(DEAD,DYING,vit/0.5);
        var px=c.x*W,py=c.y*H,pr=(c.r*(0.4+0.6*vit)*(0.85+0.15*Math.sin(c.ph)))*DPR;
        if(vit>0.35){var g=x.createRadialGradient(px,py,0,px,py,pr*2.4);g.addColorStop(0,'rgba('+col[0]+','+col[1]+','+col[2]+','+(0.34*vit)+')');g.addColorStop(1,'rgba('+col[0]+','+col[1]+','+col[2]+',0)');x.fillStyle=g;x.beginPath();x.arc(px,py,pr*2.4,0,7);x.fill();}
        x.beginPath();x.arc(px,py,pr,0,7);x.strokeStyle='rgba('+col[0]+','+col[1]+','+col[2]+','+(0.28+0.5*vit)+')';x.lineWidth=DPR;x.stroke();
        x.beginPath();x.arc(px,py,pr*0.32,0,7);x.fillStyle='rgba('+col[0]+','+col[1]+','+col[2]+','+(0.3+0.4*vit)+')';x.fill();
      }
      requestAnimationFrame(frame);
    }
    frame();
  })();

  /* ---------- savings calculator ---------- */
  (function(){
    var spend=doc.getElementById('spend');if(!spend)return;
    var sv=doc.getElementById('spendVal'),ann=doc.getElementById('annual'),rep=doc.getElementById('replaced'),bar=doc.getElementById('annBar');
    var target={a:0},cur={a:0};
    function money(n){return '$'+Math.round(n).toLocaleString('en-US');}
    function update(){var s=+spend.value;sv.textContent=money(s);var saved=(s*12)-97;target.a=Math.max(0,saved);
      var products=Math.round(s/14)+3;rep.textContent=products>15?'15+':String(products);
      bar.style.width=Math.min(100,(target.a/5000)*100)+'%';}
    spend.addEventListener('input',update);update();
    (function anim(){cur.a+=(target.a-cur.a)*0.14;ann.textContent=money(cur.a);requestAnimationFrame(anim);})();
  })();

  /* ---------- E11 value-stack sequence ---------- */
  (function(){
    var offer=doc.getElementById('offer');if(!offer||!('IntersectionObserver' in window))return;
    var items=[].slice.call(offer.querySelectorAll('.sitem')),totalEl=doc.getElementById('oVal'),nowEl=doc.getElementById('oNow'),badge=doc.getElementById('oSave');
    function money(n){return '$'+n.toFixed(2);}
    var played=false;
    function play(){
      if(played)return;played=true;
      if(reduce){totalEl.textContent='$299.86';totalEl.classList.add('struck');nowEl.classList.add('in');badge.classList.add('in');items.forEach(function(it){it.classList.add('in');});return;}
      var run=0,i=0;
      function next(){
        if(i>=items.length){
          setTimeout(function(){totalEl.classList.add('struck');
            setTimeout(function(){nowEl.classList.add('in');},520);
            setTimeout(function(){badge.classList.add('in');},780);
          },450);
          return;
        }
        var it=items[i];it.classList.add('in');var add=parseFloat(it.getAttribute('data-add'))||0;
        var from=run,to=run+add,t0=null;
        (function count(t){if(!t0)t0=t;var p=Math.min((t-t0)/380,1);totalEl.textContent=money(from+(to-from)*p);if(p<1)requestAnimationFrame(count);else{run=to;i++;setTimeout(next,230);}})(performance.now());
      }
      next();
    }
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)play();});},{threshold:.3});
    io.observe(offer);
  })();

  /* ---------- E11 urgency countdown (resets daily) ---------- */
  (function(){
    var el=doc.getElementById('ctdown');if(!el)return;
    function p(n){return (n<10?'0':'')+n;}
    function tick(){
      var now=new Date(),end=new Date(now);end.setHours(24,0,0,0);
      var d=Math.max(0,end-now);
      el.textContent=p(Math.floor(d/3.6e6))+':'+p(Math.floor(d%3.6e6/6e4))+':'+p(Math.floor(d%6e4/1000));
      setTimeout(tick,1000);
    }
    tick();
  })();
})();

<!-- ===== BEFORE / AFTER SLIDER ===== -->
(function(){
  var slider=document.getElementById('baSlider'),afterImg=document.getElementById('baAfter'),handle=document.getElementById('baHandle');
  if(!slider||!afterImg||!handle)return;
  // stop any native image/element dragging that would hijack the pointer
  slider.querySelectorAll('img').forEach(function(im){im.setAttribute('draggable','false');im.addEventListener('dragstart',function(e){e.preventDefault();});});
  var dragging=false;
  function setPos(x){var rect=slider.getBoundingClientRect();var pct=Math.max(0,Math.min(1,(x-rect.left)/rect.width))*100;afterImg.style.clipPath='inset(0 '+(100-pct)+'% 0 0)';handle.style.left=pct+'%';}
  function down(e){dragging=true;slider.style.cursor='col-resize';if(slider.setPointerCapture&&e.pointerId!=null){try{slider.setPointerCapture(e.pointerId);}catch(_){}}setPos(e.clientX);e.preventDefault();}
  function move(e){if(!dragging)return;setPos(e.clientX);e.preventDefault();}
  function up(){dragging=false;slider.style.cursor='';}
  if(window.PointerEvent){
    slider.addEventListener('pointerdown',down);
    slider.addEventListener('pointermove',move);
    window.addEventListener('pointerup',up);
    slider.addEventListener('pointercancel',up);
  }else{
    slider.addEventListener('mousedown',down);
    window.addEventListener('mousemove',function(e){move(e);});
    window.addEventListener('mouseup',up);
    slider.addEventListener('touchstart',function(e){dragging=true;setPos(e.touches[0].clientX);},{passive:true});
    window.addEventListener('touchmove',function(e){if(dragging)setPos(e.touches[0].clientX);},{passive:true});
    window.addEventListener('touchend',up);
  }
})();

<!-- ===== THEME TOGGLE (dark / bright) ===== -->
(function(){
  var root=document.documentElement,btn=document.getElementById('themeToggle');
  function icon(){var ic=btn&&btn.querySelector('.tt-ic');if(ic)ic.textContent=(root.getAttribute('data-theme')==='light'?'☾':'☀');}
  icon();
  if(btn)btn.addEventListener('click',function(){
    var next=root.getAttribute('data-theme')==='light'?'dark':'light';
    root.setAttribute('data-theme',next);
    try{localStorage.setItem('lyv-theme',next);}catch(e){}
    icon();
  });
})();

<!-- ===== SCIENCE — HORIZONTAL SLIDER ===== -->
(function(){
  var pan=document.getElementById('sciPan');
  if(pan){
    var st=pan.querySelector('.sci-pan-sticky'),
        bg=document.getElementById('sciPanBg'),
        cards=[].slice.call(document.querySelectorAll('#sciPanCards .spcard')),
        sprNow=document.getElementById('sprNow'),
        sprBar=document.getElementById('sprBar'),
        N=cards.length,last=-1;
    var cl=function(v,a,b){return Math.max(a,Math.min(b,v));};
    function panRender(){
      var total=pan.offsetHeight-st.offsetHeight;
      var p=total>0?cl(-pan.getBoundingClientRect().top/total,0,1):0;
      var range=bg.offsetWidth-st.offsetWidth;
      bg.style.transform='translateX('+(-range*p).toFixed(1)+'px)';
      var idx=cl(Math.floor(p*N),0,N-1);
      if(idx!==last){last=idx;cards.forEach(function(c,k){c.classList.toggle('on',k===idx);});if(sprNow)sprNow.textContent=('0'+(idx+1)).slice(-2);}
      if(sprBar)sprBar.style.width=(p*100).toFixed(1)+'%';
      requestAnimationFrame(panRender);
    }
    requestAnimationFrame(panRender);
  }
})();

<!-- ===== TRANSFORMATION (FIXED / STICKY SCROLL) ===== -->
(function(){
  var clamp=function(v,a,b){return Math.max(a,Math.min(b,v));};
  var lerp=function(a,b,t){return a+(b-a)*t;};
  var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;

  var trans=document.getElementById('journey');if(!trans)return;
  var faceBase=document.getElementById('faceBase'),faceDull=document.getElementById('faceDull'),faceGlow=document.getElementById('faceGlow'),sheen=document.getElementById('sheen');
  var spots=document.querySelectorAll('.spot');
  var bGlow=document.getElementById('bGlow'),bTone=document.getElementById('bTone'),bFirm=document.getElementById('bFirm');
  var vGlow=document.getElementById('vGlow'),vTone=document.getElementById('vTone'),vFirm=document.getElementById('vFirm');
  var pdate=document.getElementById('pdate');
  var whenL=document.querySelectorAll('#when .wlayer'),capL=document.querySelectorAll('#cap .clayer'),bigL=document.querySelectorAll('#bigm .mlayer'),miniL=document.querySelectorAll('#mini .mini');
  var thumbs=document.querySelectorAll('.thumb'),lines=document.querySelectorAll('.rail .line i');

  var ST=[
    {g:.12,t:.18,f:.15,day:'DAY 001'},
    {g:.44,t:.38,f:.30,day:'DAY 014'},
    {g:.71,t:.64,f:.55,day:'DAY 030'},
    {g:.96,t:.92,f:.88,day:'DAY 090'}
  ];

  function setStage(i){
    [whenL,capL,bigL].forEach(function(set){set.forEach(function(el,k){el.classList.toggle('on',k===i);});});
    miniL.forEach(function(el,k){el.classList.toggle('on',k<=i);});
    thumbs.forEach(function(el,k){el.classList.toggle('on',k===i);});
    pdate.textContent=ST[i].day;
  }
  var lastStage=-1,lastSheen=-1;

  function render(){
    var r=trans.getBoundingClientRect();
    var total=trans.offsetHeight-innerHeight;
    var p=clamp(-r.top/total,0,1);
    var fp=p*3;
    var i=Math.min(2,Math.floor(fp));
    var local=fp-i;
    var a=ST[i],b=ST[i+1]||ST[i];
    var g=lerp(a.g,b.g,local),tn=lerp(a.t,b.t,local),fm=lerp(a.f,b.f,local);

    bGlow.style.width=(g*100)+'%';bTone.style.width=(tn*100)+'%';bFirm.style.width=(fm*100)+'%';
    vGlow.textContent=Math.round(g*100)+'%';vTone.textContent=Math.round(tn*100)+'%';vFirm.textContent=Math.round(fm*100)+'%';

    faceBase.style.filter='brightness('+(0.82+g*0.42).toFixed(3)+') saturate('+(0.7+g*0.7).toFixed(3)+') contrast('+(0.92+tn*0.25).toFixed(3)+')';
    faceDull.style.opacity=(0.85*(1-g)).toFixed(3);
    faceGlow.style.opacity=(g*0.9).toFixed(3);
    spots.forEach(function(s,k){s.style.opacity=clamp(1-tn*1.25-k*0.04,0,1).toFixed(3);});

    var stage=Math.round(fp);
    if(stage!==lastStage){lastStage=stage;setStage(stage);}
    lines.forEach(function(l,k){l.style.width=clamp((fp-k)*100,0,100)+'%';});

    var crossed=Math.floor(fp+0.001);
    if(crossed!==lastSheen && local<0.12){lastSheen=crossed;sheenSweep();}

    requestAnimationFrame(render);
  }
  function sheenSweep(){
    if(reduce)return;
    sheen.style.transition='none';sheen.style.left='-60%';sheen.style.opacity='1';
    requestAnimationFrame(function(){requestAnimationFrame(function(){
      sheen.style.transition='left .9s cubic-bezier(.2,.7,.2,1),opacity .9s';sheen.style.left='110%';sheen.style.opacity='0';
    });});
  }

  if(reduce){
    // static end-state for reduced-motion users
    setStage(3);
    bGlow.style.width='96%';bTone.style.width='92%';bFirm.style.width='88%';
    vGlow.textContent='96%';vTone.textContent='92%';vFirm.textContent='88%';
    faceBase.style.filter='brightness(1.22) saturate(1.37) contrast(1.15)';faceDull.style.opacity='.03';faceGlow.style.opacity='.86';
    spots.forEach(function(s){s.style.opacity='0';});
    lines.forEach(function(l){l.style.width='100%';});
  }else{
    requestAnimationFrame(render);
  }
})();

<!-- ===== STICKY BUY BAR + CONCERN SELECTOR ===== -->
(function(){
  var ab=document.getElementById('annobar');
  function setAnnoH(){var h=(ab&&!ab.classList.contains("hide"))?ab.offsetHeight:0;document.documentElement.style.setProperty("--anno-h",h+"px");}
  setAnnoH();addEventListener("resize",setAnnoH);
  (function(){
    var opts=document.getElementById('opts'),cart=document.getElementById('ocart'),subT=document.getElementById('subToggle'),nowEl=document.getElementById('oNow');if(!opts)return;
    var items=[].slice.call(opts.querySelectorAll('.opt'));
    var selOpt=items[0]||null, mode='sub';
    function base(el){return parseFloat(((el&&el.getAttribute('data-price'))||'$97').replace(/[^0-9.]/g,''))||97;}
    function update(){
      if(!selOpt)return;
      var p=base(selOpt); if(mode==='once') p=Math.round(p*1.2);
      if(cart){cart.textContent='Add to cart — $'+p+' →';cart.setAttribute('href',selOpt.getAttribute('data-href'));}
      if(nowEl){nowEl.textContent='$'+p;}
    }
    items.forEach(function(o){o.addEventListener('click',function(){selOpt=o;items.forEach(function(x){x.classList.toggle('selected',x===o);});update();});});
    if(subT){[].slice.call(subT.querySelectorAll('.subopt')).forEach(function(b,idx){b.addEventListener('click',function(){subT.querySelectorAll('.subopt').forEach(function(x){x.classList.remove('on');});b.classList.add('on');mode=(idx===0?'sub':'once');update();});});}
    update();
  })();
  var bar=document.getElementById('buybar');
  if(bar){
    var hero=document.getElementById('hero'),footer=document.querySelector('footer');
    var journey=document.getElementById('journey');
    function upd(){
      var y=window.scrollY||window.pageYOffset||0,vh=window.innerHeight;
      var trigger=hero?hero.offsetTop+hero.offsetHeight-120:520;
      var nearFooter=footer?(y+vh>footer.offsetTop+30):false;
      // hide while the full-screen transformation module is pinned (avoids overlapping its timeline rail)
      var inJourney=journey?(y>journey.offsetTop-140 && y<journey.offsetTop+journey.offsetHeight-vh+140):false;
      bar.classList.toggle('show', y>trigger && !nearFooter && !inJourney);
    }
    window.addEventListener('scroll',upd,{passive:true});
    window.addEventListener('resize',upd);upd();
  }
  var copts=document.querySelectorAll('#concernPick .cp-opt');
  var ccard=document.getElementById('cpCard');
  if(copts.length&&ccard){
    var CDATA={
      spots:{title:"dark spots",problem:"Old pigment lingers because dull, dead cells never clear — so spots sit there for months.",fix:"Stabilized vitamin C (3-GA) and soursop antioxidants interrupt pigment at the source, while faster turnover lifts what is already there.",num:"94%",lab:"reported visibly more even tone",cta:"fade my dark spots"},
      lines:{title:"fine lines",problem:"Aging fibroblasts make less collagen and more of the enzyme that breaks it down — so lines set in and deepen.",fix:"Dual peptides quiet that enzyme and signal fresh collagen; plant stem cells wake your own repair cells.",num:"2 wks",lab:"to visibly softer fine lines",cta:"soften my fine lines"},
      dull:{title:"dull, tired skin",problem:"A congested barrier and slow turnover stop light reflecting evenly — and your actives never reach a living cell.",fix:"Phase 1 clears and rebalances the barrier so everything after it finally absorbs. The glow comes back first.",num:"week 1",lab:"when most people notice the glow",cta:"bring back my glow"},
      firm:{title:"loss of firmness",problem:"Firmness fades as the dermal matrix thins and dries — and piling actives on unprepped skin does nothing for it.",fix:"Purify, brighten, hydrate, THEN firm. By Phase 4 skin is primed to rebuild elasticity from the dermis up.",num:"week 4",lab:"firmness starts rebuilding",cta:"firm and lift my skin"}
    };
    function cprender(c){var d=CDATA[c];if(!d)return;ccard.style.opacity=0;setTimeout(function(){ccard.innerHTML='<div class="cpc-tag">your concern</div><h3 class="cpc-title">'+d.title+'</h3><div class="cpc-row"><span class="cpc-lab">the problem</span><p>'+d.problem+'</p></div><div class="cpc-row"><span class="cpc-lab">how the protocol targets it</span><p>'+d.fix+'</p></div><div class="cpc-stat"><span class="cpc-num">'+d.num+'</span><span class="cpc-slab">'+d.lab+'</span></div><a class="btn btn-primary mag" href="https://www.livyond.com/collections/all" target="_blank" rel="noopener">'+d.cta+' — $97 &rarr;</a>';ccard.style.opacity=1;},170);}
    copts.forEach(function(b){b.addEventListener('click',function(){copts.forEach(function(x){x.classList.remove('on');});b.classList.add('on');cprender(b.getAttribute('data-c'));});});
    cprender('spots');
  }
})();
/* ===== UGC: muted autoplay-in-view + tap-to-unmute ===== */
(function(){
  var cards=[].slice.call(document.querySelectorAll('#ugc .ugc-card'));
  if(!cards.length)return;
  var OFF='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line></svg> tap for sound';
  var ON='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path></svg> sound on';
  function setMuted(card,v,m){
    v.muted=m;
    var b=card.querySelector('.ugc-sound'); if(!b)return;
    if(m){b.classList.remove('on');b.innerHTML=OFF;} else {b.classList.add('on');b.innerHTML=ON;}
  }
  cards.forEach(function(card){
    var v=card.querySelector('video'); if(!v)return;
    v.muted=true; v.loop=true; v.setAttribute('playsinline','');
    var btn=document.createElement('button');
    btn.type='button'; btn.className='ugc-sound'; btn.innerHTML=OFF;
    var wrap=card.querySelector('.ugc-vid'); wrap.appendChild(btn);
    function toggle(e){
      e.preventDefault(); e.stopPropagation();
      if(v.muted){
        cards.forEach(function(c){var o=c.querySelector('video'); if(o&&o!==v) setMuted(c,o,true);});
        setMuted(card,v,false); v.play().catch(function(){});
      } else { setMuted(card,v,true); }
    }
    wrap.addEventListener('click',toggle);
  });
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){
      var card=e.target, v=card.querySelector('video'); if(!v)return;
      if(e.isIntersecting){ v.play().catch(function(){}); }
      else { v.pause(); if(!v.muted) setMuted(card,v,true); }
    });},{threshold:.55});
    cards.forEach(function(c){io.observe(c);});
  } else {
    cards.forEach(function(c){var v=c.querySelector('video'); if(v) v.play().catch(function(){});});
  }
})();